import AllhomesLazyLoadedContainer from './allhomes-lazy-loaded-container';
export default AllhomesLazyLoadedContainer;